import { Box } from "@mui/material";

export function HomeIndicator() {
  return (
    <Box
      sx={{
        height: "20px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingBottom: "4.7px",
        marginTop: "5px",
      }}
    >
      <Box
        sx={{
          width: "79px",
          height: "3px",
          backgroundColor: "common.black",
          borderRadius: "100px",
        }}
      />
    </Box>
  );
}
